<template>
  <div class="trip-textarea">
    <p
      class="ride-detailes"
      v-html="ride.text">
    </p>
  </div>
</template>

<script>
// The ride's description, as the manager wrote it (sanitised by the backend).
export default {
  name: 'RideDescription',
  props: {
    ride: { type: Object, required: true },
  },
};
</script>
